import { render, staticRenderFns } from "./license-info.vue?vue&type=template&id=04a118bd&scoped=true"
import script from "./license-info.vue?vue&type=script&lang=js"
export * from "./license-info.vue?vue&type=script&lang=js"
import style0 from "./license-info.vue?vue&type=style&index=0&id=04a118bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a118bd",
  null
  
)

export default component.exports